import { render, staticRenderFns } from "./grower-pool-splits.vue?vue&type=template&id=2042d252"
import script from "./grower-pool-splits.vue?vue&type=script&lang=js"
export * from "./grower-pool-splits.vue?vue&type=script&lang=js"
import style0 from "./grower-pool-splits.vue?vue&type=style&index=0&id=2042d252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports